import { Checkbox } from "../../../../shared/ui";
import { Controller } from "react-hook-form";

import type { FieldValues, UseControllerProps } from "react-hook-form";
import { PersonalDataAgreementModal, PersonalDataTextVacancy } from "../../../../pages/FormCandidatePage/ui/components";
import { useState } from "react";

interface VacancyControlInputTextProps<T extends FieldValues> extends UseControllerProps<T> {
    onChangeFill: () => void;
}

export const VacancyControlInputCheckbox = <T extends FieldValues>({
    name,
    control,
    onChangeFill,
}: VacancyControlInputTextProps<T>) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <>
                        <Checkbox
                            checked={value}
                            errorMessage={error?.message}
                            onChange={() => {
                                setOpenModal(true);
                            }}
                        >
                            Я&nbsp;даю согласие на&nbsp;обработку персональных данных
                        </Checkbox>
                        <PersonalDataAgreementModal
                            onAccept={() => {
                                onChange(true);
                                onChangeFill();
                            }}
                            status={openModal}
                            onClose={() => setOpenModal(false)}
                            isNew
                        >
                            <PersonalDataTextVacancy />
                        </PersonalDataAgreementModal>
                    </>
                )}
            />
        </>
    );
};
